import {BLOCK_HOUR, BLOCK_MINUTE} from "@/types/constants";

export const SPEAR_FIGHTER = {
	unit_type: 0,
	mana_cost: 50,
	gold_cost: 10,
	food_cost: 30,
	population_cost: 1,
	attack: 10,
	land_defense: 15,
	mounted_defense: 45,
	ranged_defense: 20,
	carry_capacity: 25,
	travel_speed: 18,
	training_time: BLOCK_MINUTE * 17,
	building_requirements: [],
};

export const SWORDSMAN = {
	unit_type: 0,
	mana_cost: 30,
	gold_cost: 70,
	food_cost: 30,
	population_cost: 1,
	attack: 25,
	land_defense: 50,
	mounted_defense: 15,
	ranged_defense: 40,
	carry_capacity: 15,
	travel_speed: 22,
	training_time: BLOCK_MINUTE * 25,
	building_requirements: [],
};

export const AXEMAN = {
	unit_type: 0,
	mana_cost: 60,
	gold_cost: 40,
	food_cost: 30,
	population_cost: 1,
	attack: 40,
	land_defense: 10,
	mounted_defense: 5,
	ranged_defense: 10,
	carry_capacity: 10,
	travel_speed: 18,
	training_time: BLOCK_MINUTE * 22,
	building_requirements: [{building_type: "barracks", to_level: 3}],
};

export const ARCHER = {
	unit_type: 2,
	mana_cost: 100,
	gold_cost: 60,
	food_cost: 30,
	population_cost: 1,
	attack: 15,
	land_defense: 50,
	mounted_defense: 40,
	ranged_defense: 5,
	carry_capacity: 10,
	travel_speed: 18,
	training_time: BLOCK_MINUTE * 22,
	building_requirements: [{building_type: "barracks", to_level: 5}],
};

export const LIGHT_CAVALRY = {
	unit_type: 1,
	mana_cost: 125,
	gold_cost: 250,
	food_cost: 100,
	population_cost: 4,
	attack: 130,
	land_defense: 30,
	mounted_defense: 40,
	ranged_defense: 30,
	carry_capacity: 80,
	travel_speed: 10,
	training_time: BLOCK_MINUTE * 30,
	building_requirements: [
		{building_type: "barracks", to_level: 10},
		{building_type: "stable", to_level: 1},
	],
};

export const HEAVY_CAVALRY = {
	unit_type: 1,
	mana_cost: 200,
	gold_cost: 600,
	food_cost: 150,
	population_cost: 6,
	attack: 150,
	land_defense: 200,
	mounted_defense: 80,
	ranged_defense: 180,
	carry_capacity: 50,
	training_time: BLOCK_MINUTE * 60,
	travel_speed: 11,
	building_requirements: [
		{building_type: "barracks", to_level: 15},
		{building_type: "stable", to_level: 10},
	],
};

export const RAM = {
	unit_type: 0,
	mana_cost: 300,
	gold_cost: 200,
	food_cost: 200,
	population_cost: 5,
	attack: 2,
	land_defense: 20,
	mounted_defense: 50,
	ranged_defense: 20,
	carry_capacity: 0,
	training_time: BLOCK_MINUTE * 80,
	travel_speed: 30,
	building_requirements: [
		{building_type: "barracks", to_level: 20},
		{building_type: "siege", to_level: 1},
	],
};

export const CATAPULT = {
	unit_type: 0,
	mana_cost: 320,
	gold_cost: 400,
	food_cost: 100,
	population_cost: 8,
	attack: 100,
	land_defense: 100,
	mounted_defense: 50,
	ranged_defense: 100,
	carry_capacity: 0,
	travel_speed: 30,
	training_time: BLOCK_HOUR * 2,
	building_requirements: [
		{building_type: "barracks", to_level: 30},
		{building_type: "siege", to_level: 10},
	],
};

export const SETTLER = {
	unit_type: 0,
	mana_cost: 40000,
	gold_cost: 50000,
	food_cost: 50000,
	population_cost: 100,
	attack: 30,
	land_defense: 100,
	mounted_defense: 50,
	ranged_defense: 100,
	carry_capacity: 0,
	travel_speed: 35,
	training_time: BLOCK_HOUR * 5,
	building_requirements: [
		{building_type: "hq", to_level: 30},
		{building_type: "barracks", to_level: 30},
		{building_type: "market", to_level: 20},
		{building_type: "siege", to_level: 20},
	],
};

export const MILITIA = {
	unit_type: 0,
	mana_cost: 0,
	food_cost: 0,
	gold_cost: 0,
	population_cost: 0,
	attack: 5,
	land_defense: 15,
	mounted_defense: 45,
	ranged_defense: 25,
	carry_capacity: 0,
	training_time: 0,
	travel_speed: 100,
	building_requirements: [],
};


export const UNITS = {
	'spearFighter': SPEAR_FIGHTER,
	'spear': SPEAR_FIGHTER,
	'swordsman': SWORDSMAN,
	'axeman': AXEMAN,
	'archer': ARCHER,
	'lightCavalry': LIGHT_CAVALRY,
	'light_cavalry': LIGHT_CAVALRY,
	'heavyCavalry': HEAVY_CAVALRY,
	'heavy_cavalry': HEAVY_CAVALRY,
	'ram': RAM,
	'catapult': CATAPULT,
	'settler': SETTLER,
	'militia': MILITIA,
}


export const UNITS_UNIQUE = {
	'spearFighter': SPEAR_FIGHTER,
	'swordsman': SWORDSMAN,
	'axeman': AXEMAN,
	'archer': ARCHER,
	'lightCavalry': LIGHT_CAVALRY,
	'heavyCavalry': HEAVY_CAVALRY,
	'ram': RAM,
	'catapult': CATAPULT,
	'settler': SETTLER,
	'militia': MILITIA,
}